/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equipment_Group_MachinesInputs */

const en_us2_equipment_group_machines = /** @type {(inputs: Equipment_Group_MachinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machines`)
};

const pt_br2_equipment_group_machines = /** @type {(inputs: Equipment_Group_MachinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máquinas`)
};

const es_419_equipment_group_machines = /** @type {(inputs: Equipment_Group_MachinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máquinas`)
};

const pt_pt2_equipment_group_machines = /** @type {(inputs: Equipment_Group_MachinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máquinas`)
};

const fr_fr2_equipment_group_machines = /** @type {(inputs: Equipment_Group_MachinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machines`)
};

const de_de2_equipment_group_machines = /** @type {(inputs: Equipment_Group_MachinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geräte`)
};

const it_it2_equipment_group_machines = /** @type {(inputs: Equipment_Group_MachinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macchine`)
};

/**
* | output |
* | --- |
* | "Machines" |
*
* @param {Equipment_Group_MachinesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equipment_group_machines = /** @type {((inputs?: Equipment_Group_MachinesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equipment_Group_MachinesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equipment_group_machines(inputs)
	if (locale === "es-419") return es_419_equipment_group_machines(inputs)
	if (locale === "pt-PT") return pt_pt2_equipment_group_machines(inputs)
	if (locale === "fr-FR") return fr_fr2_equipment_group_machines(inputs)
	if (locale === "de-DE") return de_de2_equipment_group_machines(inputs)
	if (locale === "it-IT") return it_it2_equipment_group_machines(inputs)
	return en_us2_equipment_group_machines(inputs)
});
export { equipment_group_machines as "equipment.group.machines" }